import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../common/html/element'
import { Input } from '../../../../../../common/html/input'
import { PopupAction } from '../../../../../../common/popup/PopupAction'
import { removeSpecials } from '../../../../../../library/helper'
import {
  changeValidateNameCreatePortfolio,
  clearValidateNameCreatePortfolio,
  selectTextValidateNamePortfolio,
} from '../../../../../../library/savedPortfolios/portfoliosOverview/store/slice/slice'
import { postCreatePortfolio } from '../../../../../../library/savedPortfolios/portfoliosOverview/store/thunk'
import {
  changeSelectedPortfolioList,
  selectSavedPortfolioList,
  selectSelectedPortfolioList,
} from '../../popupRecommendationList/store/slice'
import { getSavedPortfolio } from '../../popupRecommendationList/store/thunk'

export const PopupCreatePortfolio = ({ isShow, setShow, params = {} }) => {
  const dispatch = useDispatch()

  const [value, setValue] = useState('')
  const [isShowConfirm, setIsShowConfirm] = useState(false)

  const textValidate = useSelector(selectTextValidateNamePortfolio)
  const selectedPortfolioList = useSelector(selectSelectedPortfolioList)
  const savedPortfolioList = useSelector(selectSavedPortfolioList)

  useEffect(() => {
    if (textValidate) {
      dispatch(clearValidateNameCreatePortfolio())
    }
  }, [value, isShow])

  const handleCreateNewPortfolio = () => {
    dispatch(postCreatePortfolio({ portfolioName: value, ...params }))
      .unwrap()
      .then((res) => {
        setShow(false)
        dispatch(
          getSavedPortfolio({
            Sort: 'CreateDate',
            SortDirection: 'Descending',
            PageSize: 300,
          }),
        )
        dispatch(changeSelectedPortfolioList([...selectedPortfolioList, res]))
      })
      .finally(() => {
        setIsShowConfirm(false)
      })
  }

  const handleChangeInput = (value) => {
    setValue(removeSpecials(value.target.value))
  }

  const submitCreateNewPortfolio = () => {
    if (savedPortfolioList.map((item) => item.label).includes(value)) {
      dispatch(
        changeValidateNameCreatePortfolio(
          'companyAnalysis.peerAnalysis.VALIDATE_DUPLICATE_PORTFOLIO_NAME',
        ),
      )
    } else {
      setIsShowConfirm(true)
    }
  }

  return (
    <>
      {isShow && (
        <PopupAction
          appendStyle={{
            padding: 20,
            borderRadius: 4,
            backgroundColor: '#F3F3F3',
            width: 480,
          }}
          isShow={isShow}
          title="companyAnalysis.peerAnalysis.CREATE_NEW_PORTFOLIO"
          handleClose={() => setShow(false)}
          btnSubmit={{
            label: 'OK',
            event: submitCreateNewPortfolio,
            isI18n: true,
            disabled: !value,
          }}
          btnCancel={{
            label: 'companyAnalysis.peerAnalysis.CANCEL',
            event: () => {
              setShow(false)
            },
            isI18n: true,
          }}
        >
          <Input
            placeHolder="companyAnalysis.peerAnalysis.ENTER_NAME_PORTFOLIO"
            onChange={(value) => handleChangeInput(value)}
          />
          <Element
            style={{
              fontStyle: 'italic',
              color: '#E0505B',
              paddingTop: 4,
            }}
          >
            {textValidate && <Translate value={textValidate} />}
          </Element>
        </PopupAction>
      )}

      {isShowConfirm && (
        <PopupAction
          isShow={isShowConfirm}
          handleClose={() => {
            setIsShowConfirm(false)
          }}
          title="companyAnalysis.peerAnalysis.CREATE_PORTFOLIO"
          btnSubmit={{
            label: 'OK',
            event: () => {
              handleCreateNewPortfolio()
            },
          }}
          btnCancel={{
            label: 'companyAnalysis.peerAnalysis.CANCEL',
            event: () => {
              setIsShowConfirm(false)
            },
            isI18n: true,
          }}
        >
          <Translate value="companyAnalysis.peerAnalysis.TEXT_CREATE_PORTFOLIO" />
        </PopupAction>
      )}
    </>
  )
}
